import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ERTUserService } from "../../../services/ert-user/ert-user.service";
import { ERTMedicalRunSheetService } from "../../../services/emergency-response/medical-runsheet.service";
import { ERTMedicalRunSheet } from "../../../interfaces/emergencyresponse/medical-runsheet";
import { ERTEmergencyResponseService } from "../../../services/emergency-response/emergency-response.service";
import { ERTEmergencyResponse } from "../../../interfaces/emergencyresponse/emergencyresponse";
import { ERTUser } from "../../../interfaces/ert-user/ert-user";
import {
  RespiratoryType,
  PatientType,
  ConsciousnessLevel,
  SkinCondition,
  PulseType,
} from "../../../interfaces/emergencyresponse/medical-runsheet-enum";
import { LoggedUserService } from "../../../services/common/logged-user.service";

@Component({
  selector: "app-ert-emergency-response-addmrs-patient-vitals",
  templateUrl: "./ert-emergency-response-addmrs-patient-vitals.component.html",
})
export class ErtEmergencyResponseAddmrsPatientVitalsComponent
  implements OnInit
{
  emergencyResponseId: string;
  emergencyResponse: ERTEmergencyResponse;
  ertMedicalRunSheet: ERTMedicalRunSheet;
  ertUsers: ERTUser[] = [];
  validationMessages: string[] = [];

  respiratoryTypes = RespiratoryType;
  patientTypes = PatientType;
  consciousnessLevels = ConsciousnessLevel;
  skinConditions = SkinCondition;
  pulseTypes = PulseType;

  facilityId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ertUserService: ERTUserService,
    public ertMedicalRunSheetService: ERTMedicalRunSheetService,
    private ertEmergencyResponseService: ERTEmergencyResponseService,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private loggedUserService: LoggedUserService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.emergencyResponseId = params["emergencyResponseId"];
    });

    this.loggedUserService.getLoggedUserData().subscribe((user) => {
      this.facilityId = Number(user.facilityId) || 0;

      this.ertUserService.getAllERTUsers(this.facilityId).subscribe((data) => {
        this.ertUsers = data;
      });
    });

    this.ertEmergencyResponseService
      .getERTEmergencyResponseById(Number(this.emergencyResponseId), this.facilityId)
      .subscribe((data) => {
        this.emergencyResponse = data;
      });
  }

  submitForm(): void {
    this.validationMessages =
      this.ertMedicalRunSheetService.validateNewERTMedicalRunSheetStep3(
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm
      );

    this.scrollToTop();
    if (this.validationMessages.length > 0) {
      console.error("Validation errors:", this.validationMessages);
      return;
    }

    this.ertMedicalRunSheetService.setERTMedicalRunSheet(<ERTMedicalRunSheet>(<
      unknown
    >{
      emergencyResponseId: this.emergencyResponseId,
      emergencyResponse: this.emergencyResponse,
      icUserId: this.getICUserId(
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "incidentCommander"
        ).value
      ),
      icUser: this.getICUser(
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "incidentCommander"
        ).value
      ),
      dateAndTimeOfIncident:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "dateAndTimeIncidentOccurred"
        ).value,
      locationOfIncident:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("location")
          .value,
      medicalTeam:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("medicalTeam")
          .value,
      medicalSignOff:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "medicalSignOff"
        ).value,
      patientName:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("patientName")
          .value,
      patientAge:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("patientAge")
          .value,

      patientGender:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "patientGender"
        ).value !== null
          ? this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
              "patientGender"
            ).value
          : null,

      patientHospital:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("hospital")
          .value,
      patientEmployer:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("employer")
          .value,
      dateTimePatientArrival:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "dateAndTimeOfArrival"
        ).value
          ? this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
              "dateAndTimeOfArrival"
            ).value
          : null,
      comments:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("comments")
          .value,
      isReadiedForNextRun:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "readiedForNextRun"
        ).value,
      isFuelOk:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("okFuel")
          .value,
      cheifComplaint:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "chiefComplaint"
        ).value,
      history:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("history")
          .value,
      assessment:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("assessment")
          .value,
      treatment:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("treatment")
          .value,
      equipment:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("equipment")
          .value,
      respiratory:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("respiration")
          .value !== null
          ? Number(
              this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
                "respiration"
              ).value
            )
          : null,

      type:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("type")
          .value !== null
          ? Number(
              this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("type")
                .value
            )
          : null,
      systolicRate:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "systolicRate"
        ).value,
      levelOfConsciousness:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("levelOfCons")
          .value !== null
          ? Number(
              this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
                "levelOfCons"
              ).value
            )
          : null,

      skin:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("skin")
          .value !== null
          ? Number(
              this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("skin")
                .value
            )
          : null,

      pulseType:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("pulseType")
          .value !== null
          ? Number(
              this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
                "pulseType"
              ).value
            )
          : null,

      dateTimeOfRecord:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "dateAndTimeTaken"
        ).value
          ? this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
              "dateAndTimeTaken"
            ).value
          : null,
      pulseRate:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("pulseRate")
          .value,
      diastolicRate:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get(
          "diastolicRate"
        ).value,
      diastolicPupils:
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.get("pupils")
          .value,
    }));

    this.ertMedicalRunSheetService.addERTMedicalRunSheet(this.facilityId).subscribe({
      next: (data) => {
        this.router.navigate(
          ["/ert-emergency-response/emergency-response-view"],
          {
            queryParams: {
              emergencyResponseId: this.emergencyResponseId,
            },
          }
        );
        this.ertMedicalRunSheetService.ertMedicalRunSheetForm.reset();
      },
      error: (error) => {},
    });
  }

  getICUser(userId: string): ERTUser {
    return this.ertUsers.find((user) => user.fullName === userId);
  }

  getICUserId(incidentCommander: string): number {
    const user = this.ertUsers.find((u) => u.fullName === incidentCommander);
    return user.id;
  }

  getEnumKeys(enumObj: any): string[] {
    return Object.keys(enumObj).filter((key) => isNaN(Number(key)));
  }

  private scrollToTop() {
    this.renderer.setProperty(document.documentElement, "scrollTop", 0);
    this.renderer.setProperty(document.body, "scrollTop", 0);
  }
}
